/**
 * @author wuTao
 * @description 资源列表
 * @Date 2022/04/15
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,utils_tool ,component_tool} from '@/tool';
import { interactLiveResourcesExcelColumns } from './excelColumns';
import moment from "moment";
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
let {  WizBrowserExport } = component_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
const formatterDay = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
class InteractLiveResources extends WizContainer {

  componentName = 'interactLiveResources';

  constructor(props) {
    super(props);
    this.state = {
      AddTimestamp: new Date().getTime()
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = interactLiveResourcesExcelColumns;
    if (o['success']) {
      let _data = [];
      let data = o['data']
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _d.userTypeStr = d.userType ===1 ? "免费" : d.userType ===2 ?  "授权" : "预置";
        _d.typeStr = d.type ===0 ? "zoom资源帐户" : d.type ===1 ?  "远程评估" : "直播课堂/远程认证";
        _d.statusStr = d.status ===0 ? "禁用" :  "激活";
        _d.expirationTimeStr = d.expirationTime ? formatterDay(d.expirationTime) : "";
        _data.push(_d);
      });
      let dateTime = formatterDate(new Date());
      WizBrowserExport({
        title: '直播资源账号',
        sheetName: '直播资源账号',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '直播资源账号-'+dateTime+'.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:_templateConfig,
      apiDataFormat: {
        export: this._handleFile,
        batchCreateZoomUserResources: this._handleCMD,
        updateStatus: this._handleCMD,
        batchSyncUserResourcesUserType: this._handleCMD,
      },

    })
    return <WizReduxTemplate {..._reduxTemplateCofig}  />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(InteractLiveResources);
